"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CutterProperty = ({ name, value }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, value ? (react_1.default.createElement("div", { className: "znd-cutter-property" },
        react_1.default.createElement("div", { className: "t-body-tiny text-muted" }, name),
        react_1.default.createElement("div", { className: "t-body-small" }, value))) : null));
};
exports.default = CutterProperty;
